import { mesaColorNames, spacing } from '@/src/common/theme'
import { ScrollView, SectionList, View } from 'react-native'
import { FeedEmptyState } from './EmptyState'
import { FeedItem } from './Item'
import { FeedSectionHeader } from './SectionHeader'
import { FeedItemSkeleton } from './ItemSkeleton'
import { FeedFooterItem } from './FooterItem'
import { DesignSystem } from '@/src/design-system'
import {
  notificationCenterHorizontalPadding,
  notificationCenterVerticalPadding,
} from '@/src/experiences/notifications/screens/Center'
import {
  NOTIFICATION_FILTERS,
  useUserNotifications,
} from '@/src/experiences/notifications/hooks/useUserNotifications'

/**
 * King
 * Before moving this to design system make all make dynamic components
 */
export function Feed() {
  const { selectedFilter, setSelectedFilter, sections, loading, refetch, fetchMoreNotifications } =
    useUserNotifications()

  return (
    <View style={{ flex: 1, flexGrow: 1 }}>
      <View
        style={{
          backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
          flex: 1,
          flexGrow: 1,
        }}
      >
        <ScrollView
          horizontal
          style={{
            flexGrow: 0,
            flexDirection: 'row',
            paddingVertical: notificationCenterVerticalPadding,
          }}
          contentContainerStyle={{
            paddingHorizontal: notificationCenterHorizontalPadding,
            paddingBottom: spacing.base,
          }}
        >
          {NOTIFICATION_FILTERS.map((filter) => (
            <DesignSystem.Chip
              key={filter}
              label={filter === 'Received' ? 'Unread' : filter}
              selected={selectedFilter === filter}
              onPress={() => setSelectedFilter(filter)}
            />
          ))}
        </ScrollView>
        <SectionList
          style={{ flex: 1 }}
          showsVerticalScrollIndicator={false}
          stickySectionHeadersEnabled
          scrollEventThrottle={16}
          sections={sections}
          refreshing={loading && !sections.length}
          onRefresh={() => void refetch()}
          onEndReached={() => void fetchMoreNotifications()}
          onEndReachedThreshold={0.5}
          ListEmptyComponent={loading ? undefined : <FeedEmptyState />}
          ListFooterComponent={
            loading && sections.length ? <FeedItemSkeleton /> : <FeedFooterItem />
          }
          keyExtractor={({ notification: { id } }) => id}
          renderItem={({ item }) => <FeedItem {...item} />}
          renderSectionHeader={({ section }) => <FeedSectionHeader title={section.title} />}
          contentContainerStyle={{ paddingBottom: 32 }}
        />
      </View>
    </View>
  )
}
